import I18n from 'i18n-js'
import UserService from '../services/user_service'

export default class Header {
  constructor(el) {
    this.el = el
    this._bindUiElements()

    if (this.el.querySelector('.wz-header-login') != null) {
      this.ui.logoutButton.addEventListener('click', e => {
        e.preventDefault()
        this._logout()
      })

      this._checkLoginState()
    }

    if (this.ui.hamburger != null) {
      this.ui.hamburger.addEventListener('click', this._toggleMenu)
    }
  }

  _toggleMenu = () => {
    this.el.classList.toggle('wz-header--open')
  }

  _checkLoginState() {
    new UserService().getCurrent().done(user => {
      if (user != null) {
        this._showLoggedInUser(user)
      } else {
        this.ui.loginButton.classList.remove('wz-hidden')
      }
    })
  }

  _showLoggedInUser(user) {
    this.ui.loginButton.classList.add('wz-hidden')
    this.ui.loggedInItems.classList.remove('wz-hidden')
    this.ui.loggedInUser.innerText = I18n.t('application.header_login.hi', {
      user: user.getFullName()
    })
  }

  _bindUiElements() {
    this.ui = {
      hamburger: this.el.querySelector('.wz-header__hamburger'),
      logoutButton: this.el.querySelector('.logout-button'),
      loginButton: this.el.querySelector('.login-button'),
      loggedInItems: this.el.querySelector('.logged-in-items'),
      loggedInUser: this.el.querySelector('.logged-in-user')
    }
  }

  _logout() {
    new UserService().logout().then(() => this._switchToLoggedOutState())
  }

  _switchToLoggedOutState() {
    this.ui.loginButton.classList.remove('wz-hidden')

    this.ui.loggedInUser.innerText = ''
    this.ui.loggedInItems.classList.add('wz-hidden')
    this.ui.logoutButton.classList.add('wz-hidden')
  }

  static initialize() {
    const el = document.querySelector('.wz-header')
    if (el != null) {
      new Header(el)
    }
  }
}
